/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsChevronLeft: {
  name: 'chevron-left';
  data: string;
} = {
  name: 'chevron-left',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.707 7.293a1 1 0 0 1 0 1.414L11.414 12l3.293 3.293a1 1 0 0 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0Z" fill="currentColor"/></svg>`,
};
